import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket!: Socket;

  private readonly url = 'https://backend-chat.shuwier.com';

  connect(token: string): void {
    if (this.socket?.connected) {
      return;
    }

    this.socket = io(this.url, {
      path: '/socket.io',

      auth: {
        token,
      },

      transports: ['polling', 'websocket'],

      secure: true,

      reconnection: true,
      reconnectionAttempts: 5,

      timeout: 10000,

      forceNew: true,
    });

    this.registerConnectionEvents();
  }

  disconnect(): void {
    this.socket?.disconnect();
  }

  emit(event: string, data?: any): void {
    this.socket?.emit(event, data);
  }

  on<T>(event: string): Observable<T> {
    return new Observable((observer) => {
      this.socket.on(event, (data: T) => {
        observer.next(data);
      });

      return () => this.socket.off(event);
    });
  }

  private registerConnectionEvents(): void {
    this.socket.on('connect', () => {
      console.log('✅ Connected:', this.socket.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('❌ Disconnected:', reason);
    });

    this.socket.on('connect_error', (err) => {
      console.error('Connection Error:', err.message);
    });
  }
}
